import { TableUIProvider } from "../../contexts/TableUIContext";
import Students from "./Students";

export default function StudentsWrapper() {
    return (
        <TableUIProvider>
            <Students />
        </TableUIProvider>
    );
}
